// Normalize API URL by removing trailing slashes to prevent double slashes
const normalizeUrl = (url) => url ? url.replace(/\/+$/, '') : url;

export const MT_CAREER = "https://careers.mediatropy.com";
export const API_URL = normalizeUrl(process.env.VITE_API_URL);

export const API_SETTINGS = API_URL + "/settings";
export const API_ADMIN = API_URL + "/admin";

export const API_RECRUITMENT = API_URL + "/recr";
export const API_VACANCIES = API_RECRUITMENT + "/vacancy";
export const API_USERS = API_RECRUITMENT + "/user";
export const API_DEPARTMENTS = API_RECRUITMENT + "/department";
export const API_OFFICES = API_RECRUITMENT + "/office";
export const API_LANGUAGES = API_RECRUITMENT + "/language";
export const API_COUNTRIES = API_RECRUITMENT + "/country";
export const API_TALENTS = API_RECRUITMENT + "/talent";
export const API_PLATFORMS = API_RECRUITMENT + "/platform";
export const API_VACANCY_HISTORY = API_RECRUITMENT + "/vacancy-history";
export const API_CLIENT = API_RECRUITMENT + "/client";
export const API_CURRENCIES = API_RECRUITMENT + "/currency";
export const API_APPLICATIONS = API_RECRUITMENT + "/application";
export const API_TRACKING = API_RECRUITMENT + "/tracking-link";
export const API_SKILL = API_RECRUITMENT + "/skill";
export const API_EVALUATION_TEMPLATES =
    API_RECRUITMENT + "/evaluation-template";
export const API_QUESTIONS = API_RECRUITMENT + "/question";
export const API_EVALUATION_SKILL = API_RECRUITMENT + "/evaluation-skill";
export const API_EVALUATION_VACANCY =
    API_RECRUITMENT + "/vacancy-evaluation-skill";
export const API_EVALUATION_SCORE = API_RECRUITMENT + "/evaluation-score";
export const API_EVALUATION_ADMIN = API_RECRUITMENT + "/admin";
export const API_ANSWER = API_RECRUITMENT + "/answer";
export const API_APPROVER = API_RECRUITMENT + "/approver";
export const API_DASHBOARD = API_RECRUITMENT + "/dashboard";
export const API_VENDORS = API_RECRUITMENT + "/vendors";
export const API_EMAIL = API_RECRUITMENT + "/email";
export const API_ACTIVITIES = API_RECRUITMENT + "/activity";
export const API_VECTOR = API_RECRUITMENT + "/vector-database";
export const API_PROMPT = API_RECRUITMENT + "/prompt";

// Projects
export const API_PROJECTS = API_URL + "/project";

// Checklist methods (migrated to Node.js)
export const API_CHECKLIST = "/checklist";
export const API_CHECKLIST_TEMPLATES = API_CHECKLIST + "/template";
export const API_CHECKLIST_TASK = API_CHECKLIST + "/task";
export const API_CHECKLIST_TASK_CREATIVE = API_CHECKLIST + "/task-creative";
export const API_CHECKLIST_LOGS = API_CHECKLIST + "/logs";
export const API_CHECKLIST_PROMPTS = API_CHECKLIST + "/prompts";
export const API_CHECKLIST_GENERATE = API_CHECKLIST + "/generate-tasks";

// Task Queue endpoints (for queue management and task claiming)
export const API_TASK_QUEUES = API_CHECKLIST_TASK + "/queues";

// Task comment/ticketing endpoints (use API_CHECKLIST_TASK as base)
// Comments: GET/POST /task/:taskId/comments, PUT/DELETE /task/:taskId/comments/:commentId
// Attachments: POST /task/:taskId/comments/:commentId/attachments
// Google Drive: POST /task/:taskId/comments/:commentId/google-drive-link
// Timeline: GET /task/:taskId/timeline

// ChatBot methods
export const API_CHATBOT = API_URL + "/chatbot";

// Q&A methods
export const API_QNA = API_URL + "/qna";
// export const API_CHECKLIST_TEMPLATES = API_CHATBOT + "/template";

// Company Directory methods
export const API_COMPANY_DIRECTORY = API_URL + "/company-directory";

// User Status
export const USER_STATUS = {
    joining: {
        label: "Joining",
        label_alt: "Joining",
        color: "#d48806",
    },
    new: {
        label: "New User",
        label_alt: "New",
        color: "#eee",
    },
    off: {
        label: "Out of office",
        label_alt: "OOO",
        color: "#ccc",
    },
    working: {
        label: "Working",
        label_alt: "W",
        color: "#f6c026",
    },
    working_home: {
        label: "Working from home",
        label_alt: "WFH",
        color: "#33b679",
    },
    working_aboard: {
        label: "Working from abroad",
        label_alt: "WFA",
        color: "#b8a6cc",
    },
    break: {
        label: "On break",
        label_alt: "B",
        color: "#a25ddc",
    },
    sick: {
        label: "Out sick",
        label_alt: "S",
        color: "#616161",
    },
    leave: {
        label: "On leave",
        label_alt: "L",
        color: "#7986cb",
    },
};

//Lead
export const API_LEAD = API_URL + "/lead";

// Reports
export const API_REPORT = API_URL + "/report";

//email
export const API_EMAIL_BANNERS = API_SETTINGS + "/email-banner";
export const API_EMAIL_TEMPLATES = API_ADMIN + "/email-templates";
export const API_EMAIL_CATEGORIES = API_ADMIN + "/email-categories";
export const API_SIGNATURE_TEMPLATES = API_SETTINGS + "/signature-template";
